export const selectActiveSlug = state => state.schedule.activeSlug;

export const selectActiveIndex = state => state.schedule.activeIndex;
